export const parseWindowLocationHash = (hash: string) =>
  hash
    .substring(1)
    .split("&")
    .reduce((result, item) => {
      const [key, value] = item.split("=");
      result[key] = value;
      return result;
    }, {});
